<template>
  <a-card :bordered="false">
    <search-page-view
      ref="pageList"
      :itemNames="['name_1','name_2']"
      :columns="getColumns()"
      :col="4"
      :queryParams="queryParams"
      :requestPromise="getListPromise"
      :buttonItems="['update']"
    >
      <a-form-item slot="name_1" label="商品名称" v-bind="searchItemLayout">
        <a-input v-model="queryParams.proName" placeholder="请输入商品名称"/>
      </a-form-item>
      <a-form-item slot="name_2" label="订单号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.orderNo" placeholder="请输入平台订单号"/>
      </a-form-item>
      <template slot="userSlot" slot-scope="rowItem">
        <div>{{ rowItem.record.contactName }}</div>
        <div>{{ rowItem.record.phone }}</div>
      </template>
      <span slot="action" slot-scope="rowItem">
        <a-popconfirm v-if="rowItem.record.status === 3" title="是否要退款当前订单?"
                      @confirm="refundEvent(rowItem.record)">
          <a>退款</a>
        </a-popconfirm>
        <span v-else>--</span>
      </span>
    </search-page-view>
  </a-card>
</template>

<script>
import YlHotelMixins from '@/views/service/serviceProvider/ylHotel/mixins/YlHotelMixins'

export default {
  name: 'YlHotelOrderList',
  mixins: [YlHotelMixins],
  data() {
    return {
      queryParams: {
        proName: '',
        orderType: 35
      },
      searchItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      },
      refundLoading: false
    }
  },
  methods: {
    getListPromise(params) {
      return this.getHttpServices().getOrderService().post('direct/getDirectOrderPage', params)
    },
    getColumns() {
      return [
        {
          title: '订单号（艺龙）',
          dataIndex: 'supplerOrderNo'
        },
        {
          title: '订单号',
          dataIndex: 'orderNo'
        },
        {
          title: '商品名称',
          dataIndex: 'proName',
          width: '26%'
        },
        {
          title: '下单用户',
          dataIndex: 'contactName',
          scopedSlots: { customRender: 'userSlot' }
        },
        {
          title: '订单来源',
          dataIndex: 'sourceStr'
        },
        {
          title: '订单状态',
          dataIndex: 'statusStr'
        },
        {
          title: '下单时间',
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    refundEvent(record) {
      if (!this.refundLoading) {
        this.refundLoading = true
        const params = {
          orderNo: record.orderNo,
          source: record.source,
          directType: 35
        }
        this.getHttpServices().getOrderService().post('direct/yilongOrderRefund', params).then(() => {
          this.$message.success('退款成功')
          this.$refs.pageList.refresh()
        }).catch(reason => this.showNetWorkErrorMessage(reason)).finally(() => this.refundLoading = false)
      }
    }
  }
}
</script>

<style scoped>

</style>
